module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"stock_pcs":"Склад","order":"Добавить","available":"Наличие"},"en":{"stock_pcs":"Stock","order":"Add","available":"Availability"}}')
  delete Component.options._Ctor
}
